import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const AddComponent = LoadComponentWithRetry(() => import('./AddProcoreIntegrationMappingPage'));
const EditComponent = LoadComponentWithRetry(() => import('./EditProcoreIntegrationMappingPage'));

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/add`} component={AddComponent} />
      <Route path={`${path}/:uid`} component={EditComponent} />
    </Switch>
  );
};

export default Routes;
